import {gaScopeType} from '../../../../../../../../../../util/uiconstants';

const mapOption = ({gaScopeId, gaScopeName}) => ({
	id: gaScopeId,
	value: gaScopeId,
	label: gaScopeName,
	title: gaScopeName
});

export const getFormattedScopes = (optionsToDisplay, selectedScopeId) => {
	if (optionsToDisplay?.length === 0 || !optionsToDisplay) return null;

	const nOptions = optionsToDisplay
		.filter(({gaScopeTypeId, gaScopeId}) => gaScopeId === selectedScopeId || gaScopeTypeId !== gaScopeType.review)
		.map(mapOption);

	return nOptions;
};

export const getFormattedComponents = (optionsToDisplay, notApplicable, gaRoleTypes) => {
	let newOptions = [
		{
			id: notApplicable.id,
			value: notApplicable.id,
			label: notApplicable.displayName,
			title: notApplicable.displayName
		}
	];
	let optionsToDisplayFormatted = optionsToDisplay
		?.filter((comp) => comp.role === gaRoleTypes.regional && comp.gaParentComponentId === null)
		?.map((i) => ({
			id: i.gaComponentId,
			value: i.gaComponentId,
			label: i.name,
			title: i.name
		}));
	if (!!optionsToDisplayFormatted) newOptions = [...newOptions, ...optionsToDisplayFormatted];
	return newOptions;
};

export const getFormattedPointOfContact = (optionsToDisplay) => {
	if (optionsToDisplay?.length === 0 || !optionsToDisplay) return null;
	let newOptions = optionsToDisplay.map((i) => ({
		value: i.id,
		label: i.displayName,
		title: i.displayName
	}));
	return newOptions;
};
